import React from 'react'
import ReactSelect from 'react-select'
import { InputText, InputTextArea } from 'components/atoms'
import { ContentBody, ContentHeader, RowSection, RowSectionTitle, SectionContent } from '../layout'
import DataRow from './DataRow'
import { emptyValue, getMeetupPlaceLabel } from './helpers'
import OtaReservationPickupLocation from './OtaReservationPickupLocation'
import { IOtaReservation } from 'static/interfaces'
import { IOtaReservationPlaceEditor } from 'utils/otaReservation/usePlaceEditor'

interface IProps {
  otaReservation: IOtaReservation
  isEditing: boolean
  editor: IOtaReservationPlaceEditor
  google: any
}

const OperationPlaceSectionContent = ({ otaReservation, isEditing, editor, google }: IProps) => {
  if (otaReservation.post?.post_type !== 'private') {
    return (
      <SectionContent>
        <ContentHeader>場所・送迎</ContentHeader>
        <ContentBody className="single-column">
          <div className="unavailable-message">
            場所・送迎情報はツアー種別:Privateが対象です。{' '}
            {otaReservation.post?.post_type || 'ツアー未設定'} では利用できません。
          </div>
        </ContentBody>
      </SectionContent>
    )
  }

  return (
    <SectionContent>
      <ContentHeader>場所・送迎</ContentHeader>
      <ContentBody className="single-column">
        <RowSection>
          <RowSectionTitle>送迎場所</RowSectionTitle>
          <DataRow
            label="Pickup Location"
            content={
              <OtaReservationPickupLocation
                google={google}
                editable={isEditing && editor.pickupLocationEditable}
                value={isEditing ? editor.pickupLocation : otaReservation.pickup_location ?? ''}
                coordinate={isEditing ? editor.coordinate : otaReservation}
                onChangeLocation={editor.setPickupLocation}
                onChangeCoordinate={editor.setCoordinate}
              />
            }
          />
          <DataRow label="Pickup Memo" content={emptyValue(otaReservation.pickup_memo)} />
        </RowSection>
        <RowSection className="withBorder">
          <RowSectionTitle>Meetup Place（集合場所）</RowSectionTitle>
          <DataRow
            label="Meetup Place"
            content={
              isEditing && editor.meetupPlaceEditable ? (
                <ReactSelect
                  placeholder="Meetup Placeを選択"
                  options={editor.meetupPlaceOptions}
                  isClearable={true}
                  isSearchable={true}
                  filterOption={editor.customFilterOption}
                  onChange={editor.onChangeMeetupPlace}
                  value={
                    editor.meetupPlace
                      ? {
                          value: String(editor.meetupPlace.id),
                          label: getMeetupPlaceLabel(editor.meetupPlace),
                        }
                      : null
                  }
                />
              ) : otaReservation.meetup_place ? (
                <>
                  {getMeetupPlaceLabel(otaReservation.meetup_place)} (
                  <a
                    href={`/agent/meetup_places/${otaReservation.meetup_place_id}/edit`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ID: {otaReservation.meetup_place_id}
                  </a>
                  )
                </>
              ) : (
                '-'
              )
            }
          />
          <DataRow
            label="Custom Meetup Point（自由入力）"
            content={
              isEditing && editor.meetupPlaceEditable ? (
                <InputTextArea
                  name="custom_meetup_point"
                  placeholder="Meetup Placeを入力してください"
                  value={editor.customMeetupPlace.custom_meetup_point ?? ''}
                  onChangeHandler={event =>
                    editor.onChangeCustomMeetupPlace({
                      ...editor.customMeetupPlace,
                      custom_meetup_point: event.target.value,
                    })
                  }
                />
              ) : (
                emptyValue(otaReservation.custom_meetup_point)
              )
            }
            description="上のMeetup Placeも選択されている場合、表示はこちら(自由入力)が優先されます"
          />
          <DataRow
            label="Custom Meetup Point URL"
            content={
              isEditing && editor.meetupPlaceEditable ? (
                <InputText
                  name="custom_meetup_point_url"
                  inputMode="url"
                  placeholder="Meetup PlaceのURLを入力してください"
                  value={editor.customMeetupPlace.custom_meetup_point_url ?? ''}
                  onChangeHandler={event =>
                    editor.onChangeCustomMeetupPlace({
                      ...editor.customMeetupPlace,
                      custom_meetup_point_url: event.target.value,
                    })
                  }
                />
              ) : otaReservation.custom_meetup_point_url ? (
                <a
                  href={otaReservation.custom_meetup_point_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {otaReservation.custom_meetup_point_url}
                </a>
              ) : (
                '-'
              )
            }
          />
        </RowSection>
      </ContentBody>
    </SectionContent>
  )
}

export default OperationPlaceSectionContent
